import React from 'react'
import DocumentsPage from '../../document/DocumentsPage'

function CustomerDocumentPage() {
  return (
    <div className='card card-stretch card-border h-800px mt-5'>
      <div className='card-body px-0 py-3 px-5'>
        <DocumentsPage />
      </div>
    </div>
  )
}

export default CustomerDocumentPage
